import styled from "styled-components";
import {QAEnvironmentPopUpBlockerInputDefaultBox} from "./qa-environment-pop-up-blocker-password-input.default.box";

export const QaEnvironmentPopUpBlockerPasswordInputMrgreenBox = styled(QAEnvironmentPopUpBlockerInputDefaultBox)`
  color: ${({theme}) => theme.colors.textDark};
`